import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'percentCompute'
})

export class PercentComputePipe implements PipeTransform {
    public transform(partial: number, total: number, isDecimal: boolean = false): number {
        return partial/total*(isDecimal ? 1 : 100);
    }
}
